import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { delay1diib1rb84y4j as delay } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  Duration5ynfiptaqcrg as Duration,
  Duration__hashCode_impl_u4exz629donm5f9ouki as Duration__hashCode_impl_u4exz6,
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { invokeAllSafeMutable13vuy5ase10ma as invokeAllSafeMutable } from '../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { Triple1vhi3d0dgpnjb as Triple } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance } from '../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  beginUse146s8dwmfk72s as beginUse,
  Listenable3m4zqvjcbvczy as Listenable,
} from '../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp0_safe_receiver = JumpTo_getInstance().hg3_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.abn(['Delaying scroll']);
  }
  var tmp = delay($this.dg4_1.bg4_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp1_safe_receiver = JumpTo_getInstance().hg3_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.abn(['scrolling into view']);
  }
  $this.dg4_1.ag4_1.nb9($this.eg4_1, $this.fg4_1, $this.gg4_1);
  return Unit_instance;
}
var JumpTo$Target$go$slambdaClass;
function JumpTo$Target$go$slambda() {
  if (JumpTo$Target$go$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $horizontal, $vertical, $animate) {
        this.dg4_1 = this$0;
        this.eg4_1 = $horizontal;
        this.fg4_1 = $vertical;
        this.gg4_1 = $animate;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    JumpTo$Target$go$slambdaClass = $;
  }
  return JumpTo$Target$go$slambdaClass;
}
function JumpTo$Target$go$slambda_0(this$0, $horizontal, $vertical, $animate) {
  var i = new (JumpTo$Target$go$slambda())(this$0, $horizontal, $vertical, $animate);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function JumpTo$TargetHandler$setTarget$lambda() {
  return Unit_instance;
}
function JumpTo$TargetCategory$newTarget$lambda() {
  return Unit_instance;
}
var TargetClass;
function Target() {
  if (TargetClass === VOID) {
    class $ {
      constructor(view, delayBeforeScroll, action) {
        delayBeforeScroll = delayBeforeScroll === VOID ? null : delayBeforeScroll;
        this.ag4_1 = view;
        this.bg4_1 = delayBeforeScroll;
        this.cg4_1 = action;
      }
      hg4(horizontal, vertical, animate) {
        var tmp0_safe_receiver = JumpTo_getInstance().hg3_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.abn(['going to target']);
        }
        this.cg4_1();
        var tmp = this.bg4_1;
        if (!((tmp == null ? null : new (Duration())(tmp)) == null)) {
          var tmp_0 = get_AppScope();
          launch(tmp_0, VOID, VOID, JumpTo$Target$go$slambda_0(this, horizontal, vertical, animate));
        } else {
          var tmp1_safe_receiver = JumpTo_getInstance().hg3_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            tmp1_safe_receiver.abn(['scrolling into view']);
          }
          this.ag4_1.nb9(horizontal, vertical, animate);
        }
      }
      toString() {
        var tmp = this.ag4_1.toString();
        var tmp_0 = this.bg4_1;
        return 'Target(view=' + tmp + ', delayBeforeScroll=' + toString(tmp_0 == null ? null : new (Duration())(tmp_0)) + ', action=' + toString_0(this.cg4_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.ag4_1);
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.bg4_1;
        if ((tmp_1 == null ? null : new (Duration())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = Duration__hashCode_impl_u4exz6(this.bg4_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + hashCode(this.cg4_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Target()))
          return false;
        if (!equals(this.ag4_1, other.ag4_1))
          return false;
        var tmp = this.bg4_1;
        var tmp_0 = tmp == null ? null : new (Duration())(tmp);
        var tmp_1 = other.bg4_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (Duration())(tmp_1)))
          return false;
        if (!equals(this.cg4_1, other.cg4_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Target');
    TargetClass = $;
  }
  return TargetClass;
}
var TargetHandlerClass;
function TargetHandler() {
  if (TargetHandlerClass === VOID) {
    class $ {
      constructor(name) {
        this.ig4_1 = name;
        this.jg4_1 = ArrayList().w();
        this.kg4_1 = null;
        this.lg4_1 = null;
      }
      tah(listener) {
        var tmp0_safe_receiver = JumpTo_getInstance().hg3_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.abn(['Adding listener for ' + this.ig4_1]);
        }
        this.jg4_1.v(listener);
        if (!(this.lg4_1 == null)) {
          var tmp1_safe_receiver = JumpTo_getInstance().hg3_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            tmp1_safe_receiver.abn([this.ig4_1 + ' Calling listener immediately']);
          }
          listener();
        }
        return () => {
          var tmp0_safe_receiver = JumpTo_getInstance().hg3_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.abn(['Removing listener for ' + this.ig4_1]);
          }
          this.jg4_1.w3(listener);
          return Unit_instance;
        };
      }
      mg4(view, delayBeforeScroll, onScroll) {
        var tmp0_safe_receiver = JumpTo_getInstance().hg3_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.abn([this.ig4_1 + ' Adding target']);
        }
        this.kg4_1 = new (Target())(view, delayBeforeScroll, onScroll);
        onRemove(view, () => {
          var tmp;
          var tmp1_safe_receiver = this.kg4_1;
          if (view === (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ag4_1)) {
            var tmp0_safe_receiver = JumpTo_getInstance().hg3_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.abn([this.ig4_1 + ' removing target']);
            }
            this.kg4_1 = null;
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        var tmp1_safe_receiver = this.lg4_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var horizontal = tmp1_safe_receiver.cf();
          var vertical = tmp1_safe_receiver.df();
          var animate = tmp1_safe_receiver.ww();
          var tmp0_safe_receiver_0 = JumpTo_getInstance().hg3_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.abn([this.ig4_1 + ' Fulfilling awaiting target']);
          }
          var tmp1_safe_receiver_0 = this.kg4_1;
          if (tmp1_safe_receiver_0 == null)
            null;
          else {
            tmp1_safe_receiver_0.hg4(horizontal, vertical, animate);
          }
          this.lg4_1 = null;
        }
      }
      ng4(view, delayBeforeScroll, onScroll, $super) {
        var tmp;
        if (delayBeforeScroll === VOID) {
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          tmp = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
        } else {
          tmp = delayBeforeScroll;
        }
        delayBeforeScroll = tmp;
        var tmp_0;
        if (onScroll === VOID) {
          tmp_0 = JumpTo$TargetHandler$setTarget$lambda;
        } else {
          tmp_0 = onScroll;
        }
        onScroll = tmp_0;
        var tmp_1;
        if ($super === VOID) {
          this.mg4(view, delayBeforeScroll, onScroll);
          tmp_1 = Unit_instance;
        } else {
          var tmp_2 = $super.mg4;
          var tmp_3 = delayBeforeScroll;
          tmp_1 = tmp_2.call(this, view, tmp_3 == null ? null : new (Duration())(tmp_3), onScroll);
        }
        return tmp_1;
      }
      og4(horizontal, vertical, animate) {
        invokeAllSafeMutable(this.jg4_1);
        var tmp0_safe_receiver = this.kg4_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.also' call
          var tmp0_safe_receiver_0 = JumpTo_getInstance().hg3_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.abn(['Target found for ' + this.ig4_1]);
          }
          tmp = tmp0_safe_receiver;
        }
        var tmp1_safe_receiver = tmp;
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp1_safe_receiver.hg4(horizontal, vertical, animate);
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp0_safe_receiver_1 = JumpTo_getInstance().hg3_1;
          if (tmp0_safe_receiver_1 == null)
            null;
          else {
            tmp0_safe_receiver_1.abn(['No target found for ' + this.ig4_1]);
          }
          this.lg4_1 = new (Triple())(horizontal, vertical, animate);
        }
      }
      pg4(horizontal, vertical, animate, $super) {
        horizontal = horizontal === VOID ? null : horizontal;
        vertical = vertical === VOID ? Align_Start_getInstance() : vertical;
        animate = animate === VOID ? true : animate;
        var tmp;
        if ($super === VOID) {
          this.og4(horizontal, vertical, animate);
          tmp = Unit_instance;
        } else {
          tmp = $super.og4.call(this, horizontal, vertical, animate);
        }
        return tmp;
      }
    }
    protoOf($).iaj = beginUse;
    initMetadataForClass($, 'TargetHandler', VOID, VOID, [Listenable()]);
    TargetHandlerClass = $;
  }
  return TargetHandlerClass;
}
var TargetCategoryClass;
function TargetCategory() {
  if (TargetCategoryClass === VOID) {
    class $ {
      constructor(name) {
        this.qg4_1 = name;
        this.rg4_1 = ArrayList().w();
        this.sg4_1 = ArrayList().w();
        this.tg4_1 = HashMap().n8();
        this.ug4_1 = HashMap().n8();
      }
      tah(listener) {
        var tmp0_safe_receiver = JumpTo_getInstance().hg3_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.abn(['Adding listener for ' + this.qg4_1]);
        }
        this.rg4_1.v(listener);
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.ug4_1.i1()) {
          var tmp1_safe_receiver = JumpTo_getInstance().hg3_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            tmp1_safe_receiver.abn([this.qg4_1 + ' Calling listener immediately']);
          }
          listener();
        }
        return () => {
          this.rg4_1.w3(listener);
          var tmp0_safe_receiver = JumpTo_getInstance().hg3_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.abn(['Removing listener for ' + this.qg4_1 + ', ' + this.rg4_1.p1() + ' left']);
          }
          return Unit_instance;
        };
      }
      vg4(listener) {
        var tmp0_safe_receiver = JumpTo_getInstance().hg3_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.abn(['Adding item listener for ' + this.qg4_1]);
        }
        this.sg4_1.v(listener);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.ug4_1.q3().m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp0_safe_receiver_0 = JumpTo_getInstance().hg3_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.abn([this.qg4_1 + ' Calling item listener for ' + toString(element) + ' immediately']);
          }
          listener(element);
        }
        return () => {
          this.sg4_1.w3(listener);
          var tmp0_safe_receiver = JumpTo_getInstance().hg3_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.abn(['Removing listener for ' + this.qg4_1 + ', ' + this.rg4_1.p1() + ' left']);
          }
          return Unit_instance;
        };
      }
      wg4(id, view, delayBeforeScroll, onScroll) {
        var target = new (Target())(view, delayBeforeScroll, onScroll);
        // Inline function 'kotlin.collections.set' call
        this.tg4_1.s3(id, target);
        onRemove(view, () => {
          var tmp;
          var tmp1_safe_receiver = this.tg4_1.p3(id);
          if (view === (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ag4_1)) {
            var tmp0_safe_receiver = JumpTo_getInstance().hg3_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.abn(['Removing target for ' + this.qg4_1]);
            }
            this.tg4_1.t3(id);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        var tmp0_safe_receiver = this.ug4_1.p3(id);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var horizontal = tmp0_safe_receiver.cf();
          var vertical = tmp0_safe_receiver.df();
          var animate = tmp0_safe_receiver.ww();
          var tmp0_safe_receiver_0 = JumpTo_getInstance().hg3_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.abn([this.qg4_1 + ' fulfilling awaiting target']);
          }
          target.hg4(horizontal, vertical, animate);
          this.ug4_1.t3(id);
        }
      }
      xg4(id, view, delayBeforeScroll, onScroll, $super) {
        var tmp;
        if (delayBeforeScroll === VOID) {
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          tmp = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
        } else {
          tmp = delayBeforeScroll;
        }
        delayBeforeScroll = tmp;
        var tmp_0;
        if (onScroll === VOID) {
          tmp_0 = JumpTo$TargetCategory$newTarget$lambda;
        } else {
          tmp_0 = onScroll;
        }
        onScroll = tmp_0;
        var tmp_1;
        if ($super === VOID) {
          this.wg4(id, view, delayBeforeScroll, onScroll);
          tmp_1 = Unit_instance;
        } else {
          var tmp_2 = $super.wg4;
          var tmp_3 = delayBeforeScroll;
          tmp_1 = tmp_2.call(this, id, view, tmp_3 == null ? null : new (Duration())(tmp_3), onScroll);
        }
        return tmp_1;
      }
      yg4(id, horizontal, vertical, animate) {
        invokeAllSafeMutable(this.rg4_1);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = toList(this.sg4_1).m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          element(id);
        }
        var tmp0_safe_receiver = this.tg4_1.p3(id);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.also' call
          var tmp0_safe_receiver_0 = JumpTo_getInstance().hg3_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.abn(['Target found for ' + this.qg4_1]);
          }
          tmp = tmp0_safe_receiver;
        }
        var tmp1_safe_receiver = tmp;
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp1_safe_receiver.hg4(horizontal, vertical, animate);
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp0_safe_receiver_1 = JumpTo_getInstance().hg3_1;
          if (tmp0_safe_receiver_1 == null)
            null;
          else {
            tmp0_safe_receiver_1.abn(['No target found for ' + this.qg4_1]);
          }
          var tmp0 = this.ug4_1;
          // Inline function 'kotlin.collections.set' call
          var value = new (Triple())(horizontal, vertical, animate);
          tmp0.s3(id, value);
        }
      }
      zg4(id, horizontal, vertical, animate, $super) {
        horizontal = horizontal === VOID ? null : horizontal;
        vertical = vertical === VOID ? Align_Start_getInstance() : vertical;
        animate = animate === VOID ? true : animate;
        var tmp;
        if ($super === VOID) {
          this.yg4(id, horizontal, vertical, animate);
          tmp = Unit_instance;
        } else {
          tmp = $super.yg4.call(this, id, horizontal, vertical, animate);
        }
        return tmp;
      }
    }
    protoOf($).iaj = beginUse;
    initMetadataForClass($, 'TargetCategory', VOID, VOID, [Listenable()]);
    TargetCategoryClass = $;
  }
  return TargetCategoryClass;
}
var JumpToClass;
function JumpTo() {
  if (JumpToClass === VOID) {
    class $ {
      constructor() {
        JumpTo_instance = this;
        this.hg3_1 = null;
        this.ig3_1 = new (TargetHandler())('ProjectDetails');
        this.jg3_1 = new (TargetHandler())('ToDos');
        this.kg3_1 = new (TargetHandler())('ProjectMessages');
        this.lg3_1 = new (TargetHandler())('ProjectLedger');
        this.mg3_1 = new (TargetCategory())('PendingChangeOrder');
        this.ng3_1 = new (TargetCategory())('ChangeItem');
        this.og3_1 = new (TargetCategory())('LineItemCompletionFlow');
        this.pg3_1 = new (TargetCategory())('LineItemComment');
        this.qg3_1 = new (TargetCategory())('IncidentFlow');
        this.rg3_1 = new (TargetCategory())('LineItem');
        this.sg3_1 = new (TargetCategory())('ScopeView');
        this.tg3_1 = new (TargetCategory())('PayApp');
        this.ug3_1 = new (TargetCategory())('ContractorNote');
        this.vg3_1 = new (TargetCategory())('WorkTask');
        this.wg3_1 = new (TargetCategory())('PunchTask');
        this.xg3_1 = new (TargetCategory())('Credit');
        this.yg3_1 = new (TargetHandler())('ProjectSettlements');
        this.zg3_1 = new (TargetCategory())('UnlockRequest');
      }
      ag5(parameter, horizontal, vertical, animate) {
        var tmp;
        switch (parameter.p8v_1.b4_1) {
          case 0:
            tmp = this.ig3_1;
            break;
          case 1:
            tmp = this.jg3_1;
            break;
          case 2:
            tmp = this.kg3_1;
            break;
          case 5:
            tmp = this.mg3_1;
            break;
          case 6:
            tmp = this.ng3_1;
            break;
          case 7:
            tmp = this.rg3_1;
            break;
          case 8:
            tmp = this.sg3_1;
            break;
          case 9:
            tmp = this.tg3_1;
            break;
          case 10:
            tmp = this.ug3_1;
            break;
          case 11:
            tmp = this.vg3_1;
            break;
          case 12:
            tmp = this.wg3_1;
            break;
          case 3:
            tmp = this.og3_1;
            break;
          case 4:
            tmp = this.qg3_1;
            break;
          case 13:
            tmp = this.pg3_1;
            break;
          case 14:
            tmp = this.yg3_1;
            break;
          case 15:
            tmp = this.zg3_1;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var handler = tmp;
        if (handler instanceof TargetHandler()) {
          handler.og4(horizontal, vertical, animate);
        } else {
          if (handler instanceof TargetCategory()) {
            var tmp_0 = handler instanceof TargetCategory() ? handler : THROW_CCE();
            var tmp2_elvis_lhs = parameter.q8v_1;
            var tmp_1;
            if (tmp2_elvis_lhs == null) {
              throw IllegalStateException().o4(parameter.p8v_1.u8v_1 ? 'No Id for JumpTo.' + parameter.p8v_1.toString() : 'JumpTo.' + parameter.p8v_1.toString() + ' needs an ID');
            } else {
              tmp_1 = tmp2_elvis_lhs;
            }
            tmp_0.yg4(tmp_1, horizontal, vertical, animate);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
      bg5(parameter, horizontal, vertical, animate, $super) {
        horizontal = horizontal === VOID ? null : horizontal;
        vertical = vertical === VOID ? Align_Start_getInstance() : vertical;
        animate = animate === VOID ? true : animate;
        var tmp;
        if ($super === VOID) {
          this.ag5(parameter, horizontal, vertical, animate);
          tmp = Unit_instance;
        } else {
          tmp = $super.ag5.call(this, parameter, horizontal, vertical, animate);
        }
        return tmp;
      }
    }
    initMetadataForObject($, 'JumpTo');
    JumpToClass = $;
  }
  return JumpToClass;
}
var JumpTo_instance;
function JumpTo_getInstance() {
  if (JumpTo_instance === VOID)
    new (JumpTo())();
  return JumpTo_instance;
}
//region block: exports
export {
  TargetCategory as TargetCategory1szv6uyg7o310,
  TargetHandler as TargetHandler3hwg57jh7lzun,
  JumpTo_getInstance as JumpTo_getInstance3ru9x2o8nieur,
};
//endregion

//# sourceMappingURL=JumpTo.mjs.map
